const ROOT_PATH = '/bindings';

export const BindingsPaths = {
  ROOT_PATH,
} as const;
